import { Link } from "react-router-dom";
import type { Drama } from "@/types";

export default function DramaListItem({ drama }: { drama: Drama }) {
  return (
    <div className="group bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 transition-colors p-3 md:p-4">
      <div className="flex flex-col sm:flex-row gap-4">
        <Link
          to={`/detail/${drama.id}`}
          className="w-full sm:w-32 md:w-36 shrink-0 aspect-[2/3] sm:aspect-[2/3] rounded-md overflow-hidden bg-background-200 cursor-pointer"
        >
          <img
            src={drama.cover}
            alt={drama.title}
            title={`${drama.title} - 漂亮的保姆`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
        <div className="min-w-0 flex-1 flex flex-col">
          <div className="flex items-start justify-between gap-3">
            <Link
              to={`/detail/${drama.id}`}
              className="font-heading text-base md:text-lg font-semibold text-foreground-950 hover:text-primary-600 transition-colors cursor-pointer"
            >
              {drama.title}
            </Link>
            <span className="shrink-0 px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-sm font-semibold">
              {drama.rating.toFixed(1)} 分
            </span>
          </div>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-500 flex flex-wrap gap-x-3 gap-y-1">
            <span>{drama.genre}</span>
            <span>{drama.year}</span>
            <span>{drama.region}</span>
            <span>共 {drama.episodes} 集</span>
            <span className="text-accent-600">{drama.status}</span>
          </p>
          <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2">
            {drama.synopsis}
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            {drama.tags.slice(0, 3).map((t) => (
              <span
                key={t}
                className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs"
              >
                {t}
              </span>
            ))}
            <span className="text-xs text-foreground-400">导演：{drama.director}</span>
          </div>
        </div>
      </div>
    </div>
  );
}